import React, { memo, useContext } from 'react';
import { Trails } from '../slots/Trail';
import { ListItemContext } from './Item';
import { RadioBase } from '../radio';
import styles from './styles.module.css';
export const RadioTrail = memo(function RadioTrail() {
    const context = useContext(ListItemContext);
    if (!context) {
        throw new Error('List.RadioTrail should be placed inside ListBoxItem component');
    }
    const { isSelected, isHovered } = context;
    return (React.createElement(Trails.Icon, null,
        React.createElement(RadioBase, { checked: isSelected, hovered: isHovered, value: "", name: "", "aria-hidden": true, tabIndex: -1, className: styles.decorativeRadio })));
});
